import { Box, Grid, Paper, TextField, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";
import Layout from "../../components/Layout";
import { FuelRequest } from "./FuelRequest";
import { FuelResponse } from "./FuelResponse";
import { searchGridSx } from "../../utils/responsiveStyles";

export default function Fuel() {
  // 🔹 Table state
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [sortModel, setSortModel] = useState([]);

  // 🔹 Map frontend field names → backend DB names
  const orderByMap = {
    id: "id",
    type: "type",
    priceRate: "price_rate",
  };

  // 🔹 Search filters
  const [type, setType] = useState("");
  const [startPriceRate, setStartPriceRate] = useState(null);
  const [endPriceRate, setEndPriceRate] = useState(null);

  // 🔹 Fetch Data
  const fetchData = () => {
    const token = localStorage.getItem("token");
    console.log("token: " + token);
    setLoading(true);

    const request = new FuelRequest();
    request.setStartIndex(page * pageSize);
    request.setLimit(pageSize);

    if (sortModel.length > 0) {
      const sort = sortModel[0]; // { field: "codeDescription", sort: "asc" }
      const backendField = orderByMap[sort.field] || sort.field;
      console.log(`order by ${backendField} ${sort.sort?.toUpperCase()}`);
      request.setOrderBy(
        `order by ${backendField} ${sort.sort?.toUpperCase()}`
      );
    }

    if (startPriceRate) request.setPriceRangeStart(startPriceRate);
    if (endPriceRate) request.setPriceRangeEnd(endPriceRate);
    if (type) request.setName(type);

    axiosClient
      .post("/fuel/get-all-fuel-info", request)
      .then((res) => {
        const fuelResponse = new FuelResponse(res.data);
        if (fuelResponse?.getOperationResult() && fuelResponse.getFuelList()) {
          setRows(fuelResponse.getFuelList());
          setRowCount(fuelResponse.getCount());
        } else {
          setRows([]);
          setRowCount(0);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  // initial load + refetch when page/pageSize changes
  useEffect(() => {
    console.log(page, pageSize);
    fetchData();
  }, [page, pageSize, sortModel]);

  // 🔹 Columns
  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "type", headerName: "Fuel Type", flex: 1 },
    { field: "priceRate", headerName: "Price Rate", flex: 1 },
  ];

  return (
    <Layout title="Fuel">
      {/* Search Form */}
      <Paper sx={{ p: { xs: 1.5, sm: 2 }, mb: 3 }}>
        <Grid container sx={searchGridSx}>
          {/* search fields ... */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Fuel Type"
              type="text"
              value={type || ""}
              onChange={(e) => setType(e.target.value)}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Start Price Range"
              type="number"
              value={startPriceRate || ""}
              onChange={(e) => setStartPriceRate(e.target.value)}
              fullWidth
              inputProps={{ min: 0, step: 1 }} // optional: prevents negative numbers
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="End Price Range"
              type="number"
              value={endPriceRate || ""}
              onChange={(e) => setEndPriceRate(e.target.value)}
              fullWidth
              inputProps={{
                min: startPriceRate || 0, // ensures end >= start
                step: 1, // optional: restricts to integers only
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ minWidth: { sm: 180 } }}
              onClick={fetchData}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* DataGrid */}
      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => {
            setPage(model.page);
            setPageSize(model.pageSize);
          }}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={(model) => setSortModel(model)}
          sortingOrder={["asc", "desc"]}
          loading={loading}
          pageSizeOptions={[5, 10, 20, 50]}
          autoHeight
          sx={{ minWidth: { xs: 640, sm: "100%" }, bgcolor: "white" }}
        />
      </Box>
    </Layout>
  );
}
